import { render, staticRenderFns } from "./MigrationUI.vue?vue&type=template&id=03a673da&scoped=true"
import script from "./MigrationUI.vue?vue&type=script&lang=js"
export * from "./MigrationUI.vue?vue&type=script&lang=js"
import style0 from "./MigrationUI.vue?vue&type=style&index=0&id=03a673da&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a673da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a673da')) {
      api.createRecord('03a673da', component.options)
    } else {
      api.reload('03a673da', component.options)
    }
    module.hot.accept("./MigrationUI.vue?vue&type=template&id=03a673da&scoped=true", function () {
      api.rerender('03a673da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Migration/MigrationUI.vue"
export default component.exports